import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Navigate, Routes, Route } from 'react-router-dom';
import jwt from 'jsonwebtoken';
import { get } from 'lodash';

import VerticalLayout from './common/VerticalLayout';
import Loader from '../common/components/layout/Loader';
import { useCustomNavigate } from '../common/hooks/useCustomNavigate';
import { AUTH_TOKEN } from '../auth/AuthConstants';
import ProtectedRoute from '../common/hoc/ProtectedRoute';
import RouterPaths from '../constants/RouterPaths';
import Homepage from '../homepage/Homepage';
import NotFound from '../notfound/NotFound';
import { accessRoutes } from '../helpers/accessRoutes';
import useChangesCount from '../requestforchanges/useChangesCount';

function MainLayout(props) {
  const [hasMounted, setHasMounted] = useState(false);
  const [accountType, setAccountType] = useState('');
  useCustomNavigate();
  useChangesCount();

  useEffect(() => {
    setHasMounted(true);
  }, []);

  useEffect(() => {
    const authToken = localStorage.getItem(AUTH_TOKEN);
    const decode = jwt.decode(authToken);
    const type = get(decode, 'accountType', '');
    setAccountType(type);
  }, []);

  if (!hasMounted) return <Loader height="100vh" />;

  const getRoutes = (routes) => {
    if (!routes || !Array.isArray(routes)) {
      return [];
    }

    const flattenRoutes = (routesArray) =>
      routesArray.reduce((acc, prop) => {
        if (prop.collapse && Array.isArray(prop.views)) {
          return [...acc, ...flattenRoutes(prop.views)];
        }
        if (prop.children && Array.isArray(prop.children)) {
          return [...acc, ...flattenRoutes(prop.children)];
        }
        if (prop.path && prop.component) {
          return [...acc, prop];
        }
        return acc;
      }, []);

    const flattenedRoutes = flattenRoutes(routes);

    return flattenedRoutes.map((prop) => (
      <Route
        path={prop.path}
        element={<ProtectedRoute component={prop.component} />}
        key={prop.path}
      />
    ));
  };

  if (props.isAuthenticated) {
    return (
      <VerticalLayout>
        <Routes>
          <Route path="/" element={<Navigate to={RouterPaths.HOMEPAGE} replace />} />
          <Route path={RouterPaths.HOMEPAGE} element={<Homepage />} />
          {getRoutes(accessRoutes(accountType))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </VerticalLayout>
    );
  }
  return <Navigate to={RouterPaths.LOGIN} replace />;
}

const mapStateToProps = ({ auth }) => ({
  isAuthenticated: auth.get('isAuthenticated'),
});

export default connect(mapStateToProps)(MainLayout);
